import styled from 'styled-components';

import Input from '~/components/Input';

import { FooterInfoContainer, MainButton } from '../auth.styles';

export const StyledTextField = styled(Input)``;

export const SubmitButton = styled(MainButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    marginTop: '$8',
  },
}))``;

export const StyledFooter = styled(FooterInfoContainer)`
  margin-top: 1rem;
`;
